import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=06fedd2e&scoped=true"
var script = {}
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=06fedd2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fedd2e",
  null
  
)

export default component.exports